import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function Blog() {
  return (
    <>
      <Helmet>
        <title>Blog | BeArt Művészetterápia</title>
        <meta name="description" content="BeArt Művészetterápia blog" />
        <link rel="canonical" href="https://beart.hu/blog" />
      </Helmet>
      
      <div className="beart-section">
        <h1 className="beart-title">Blog</h1>
        <p>Hamarosan...</p>
      </div>
    </>
  )
}
